import classnames from 'classnames';

import styles from './Loader.module.scss';
import { LoaderProps } from './Loader.types';

export const Loader = ({ size, variant = 'primary', className }: LoaderProps) => (
  <div className={classnames(styles.loader, styles[size], styles[variant], className)}>
    <div className={styles.dot} />
    <div className={styles.dot} />
    <div className={styles.dot} />
  </div>
);
